import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=cd6385b6&scoped=true&lang=pug&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=cd6385b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6385b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VContainer,VContent,VDataTable})
